import NewCommonServiceHero from "../../../common/NewCommonServices/NewCommonServiceHero";
import NewCommonServiceForm from "../../../common/NewCommonServices/NewCommonServiceForm";
import NewCommonMoreItService from "../../../common/NewCommonServices/NewCommonMoreItService";
import {
  SoftwareAndSaasDevelopmentIcon,
  WebsiteAndAppDevelopmentIcon,
  cyberSecurity,
  itSupportAndMaintainance,
  mobileAndAppDevelopment,
} from "../../../../assets/icons/serviceIcon/index";
import CloudAndDevopsWork from "./CloudAndDevopsWork";

const items = [
  {
    name: "Cloud Infrastructure",
    text: "Your business shouldn’t slow down as it grows. We set up secure, scalable cloud solutions that keep everything running smoothly, so you focus on growth, not glitches.",
  },
  {
    name: "CI/CD Automation",
    text: "No more stressful updates or downtime. We automate your development pipeline, making deployments faster, smoother and error-free, so your team can build without the bottlenecks.",
  },
  {
    name: "Cloud Security & Compliance",
    text: "Security shouldn’t be an afterthought. We put strong security and compliance measures in place, so your data stays safe and your business runs without worries.",
  },
];

const otherService = [
  {
    icon: mobileAndAppDevelopment,
    name: "Mobile App Development",
    des: "We build apps that feel smooth, look great, and keep your users hooked.",
    path: "/mobile-app-development",
  },
  {
    icon: WebsiteAndAppDevelopmentIcon,
    name: "Website & App Development",
    des: "We build websites that tell stories, connect hearts and build brands.",
    path: "/web-app-development",
  },
  {
    icon: SoftwareAndSaasDevelopmentIcon,
    name: "Software & SaaS Development",
    des: "Smart, scalable, and built for the long run - software that grows with you.",
    path: "/software-saas-development",
  },
  {
    icon: cyberSecurity,
    name: "Cybersecurity & Data Protection",
    des: "Your data stays yours! We lock it down so hackers don’t stand a chance.",
    path: "/cybersecurity-data-protection",
  },
  {
    icon: itSupportAndMaintainance,
    name: "IT Support & Maintenance",
    des: "Seamless IT services to protect and power your business growth.",
    path: "/it-support-maintenance",
  },
];

const CloudAndDevopsDevelopment = () => {
  return (
    <div>
      <NewCommonServiceHero
        heading="Cloud & Devops"
        colorHeading="Develpoment"
        description="No more slow systems or security worries. We handle cloud and DevOps, so your business runs like a dream - fast, secure and always ready to grow."
      />
      <NewCommonServiceForm title="Cloud & Devops Development" items={items} />
      <CloudAndDevopsWork/>
      <NewCommonMoreItService items={otherService} />
    </div>
  );
};

export default CloudAndDevopsDevelopment;
